import moment from 'moment-timezone';
import { DOOH_REPORT_AVAILABILITY_OFFSET_DAYS } from 'sonata-static-storage/lib/entities/doohReport/doohReport.constants';

const DEFAULT_TIMEZONE = 'UTC';

export function isDoohReportAvailable(endDate?: Date | string | null, timezone?: string): boolean {
  if (!endDate) {
    return false;
  }

  const zone = timezone && moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
  const availableFrom = moment.tz(endDate, zone).add(DOOH_REPORT_AVAILABILITY_OFFSET_DAYS, 'days').startOf('day');

  return moment().isSameOrAfter(availableFrom);
}
